import apiClient from './apiClient'

function downloadBlob(data: Blob, fileName: string) {
  const url = window.URL.createObjectURL(data)
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', fileName)
  document.body.appendChild(link)
  link.click()
  link.remove()
  window.URL.revokeObjectURL(url)
}

// Ořez názvu na cca maxLen znaků, ale ideálně na nejbližší mezeře vlevo (neřeže uprostřed slova).
// Pokud v okně `window` znaků vlevo od maxLen žádná mezera není, ořízne se natvrdo na maxLen.
function truncateAtWord(name: string, maxLen = 40, window = 15): string {
  if (name.length <= maxLen) return name
  const head = name.slice(0, maxLen)
  const lastSpace = head.lastIndexOf(' ')
  return lastSpace >= maxLen - window ? head.slice(0, lastSpace).trimEnd() : head
}

/** Při chybě s responseType:'blob' přečte tělo chyby jako text */
async function readBlobError(err: unknown): Promise<never> {
  const anyErr = err as any
  const blobData = anyErr?.response?.data
  if (blobData instanceof Blob) {
    try {
      const text = await blobData.text()
      const json = JSON.parse(text)
      anyErr.response.data = json
    } catch { /* ponechat jako Blob */ }
  }
  throw anyErr
}

export const exportsService = {
  downloadAttendance: async (year: number, month: number) => {
    const response = await apiClient.get('/exports/attendance', {
      params: { year, month },
      responseType: 'blob',
    })
    downloadBlob(new Blob([response.data]), `Dochazka_${String(month).padStart(2, '0')}_${year}.xlsx`)
  },

  downloadEmployees: async () => {
    const response = await apiClient.get('/exports/employees', {
      responseType: 'blob',
    })
    const today = new Date().toISOString().slice(0, 10)
    downloadBlob(new Blob([response.data]), `Zamestnanci_export_${today}.xlsx`)
  },

  downloadContractors: async () => {
    const response = await apiClient.get('/exports/contractors', {
      responseType: 'blob',
    })
    const today = new Date().toISOString().slice(0, 10)
    downloadBlob(new Blob([response.data]), `Externiste_export_${today}.xlsx`)
  },

  downloadPensionContributions: async () => {
    const today = new Date().toISOString().slice(0, 10)
    const response = await apiClient
      .get('/exports/pension-contributions', { responseType: 'blob' })
      .catch(readBlobError)
    downloadBlob(new Blob([response.data]), `Prispevky_na_stari_${today}.xlsx`)
  },

  downloadPensionContributionsPayroll: async () => {
    const today = new Date().toISOString().slice(0, 10)
    const response = await apiClient
      .get('/exports/pension-contributions/payroll', { responseType: 'blob' })
      .catch(readBlobError)
    downloadBlob(new Blob([response.data]), `Prispevky_na_stari_mzdova_${today}.xlsx`)
  },

  downloadApprovedVacations: async (year: number, month: number) => {
    const response = await apiClient
      .get('/exports/approved-vacations', { params: { year, month }, responseType: 'blob' })
      .catch(readBlobError)
    const mm = String(month).padStart(2, '0')
    downloadBlob(new Blob([response.data]), `Schválené dovolené ${mm}_${year}.xlsx`)
  },

  downloadApprovedPaidLeave: async (year: number, month: number) => {
    const response = await apiClient
      .get('/exports/approved-paid-leave', { params: { year, month }, responseType: 'blob' })
      .catch(readBlobError)
    const mm = String(month).padStart(2, '0')
    downloadBlob(new Blob([response.data]), `Schválené Placené volno ${mm}_${year}.xlsx`)
  },

  downloadDocumentDefinition: async (id: number, docName: string) => {
    const response = await apiClient
      .get(`/exports/document-definitions/${id}`, { responseType: 'blob' })
      .catch(readBlobError)
    const today = new Date().toISOString().slice(0, 10)
    const cleaned = docName.replace(/[^a-zA-Z0-9áčďéěíňóřšťúůýžÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ ]/g, '').replace(/\s+/g, ' ').trim()
    const safeName = truncateAtWord(cleaned).replace(/ /g, '_')
    downloadBlob(new Blob([response.data]), `Dokument_${safeName}_${today}.xlsx`)
  },
}
